/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  RentPrices loadData func
 */

import type { RouteComponentProps } from '@zcode/router-utils'
import {
  selectCityFromRouteProps,
  selectNeighborhoodFromRouteProps,
} from '../module/selectors/router'
import { loadLocalePriceData } from '../module/thunks'
import type { Store } from '../module/types'

export const loadData = async (
  { dispatch }: Store,
  routeProps: RouteComponentProps<{ locationPath: string }>
) => {
  const cityState = selectCityFromRouteProps(routeProps)
  const hoodPath = selectNeighborhoodFromRouteProps(routeProps)
  return await dispatch(loadLocalePriceData({ cityState, hoodPath }))
}
